/**
 * Custom api list on which loader has to be shown.
 * Add your api in this list and provide id of loader element (loaderId) which you can find from loader.component.html
 * In case you have new loader, add that element in the said html file and provide its id
 * The loader text has been removed for now but I've kept it as it is here in the list so that we
 * can easily revert back to loader text in case its needed.
 */
export const LoaderApis = [
  {
    api: "/api/Playbooks/GetFullPlaybookManifest",
    loaderId: "vPlaybookLogo",
    text: "Loading Playbook",
  },
  {
    api: "/api/Profiles/GetProfileswithFilters",
    loaderId: "simpleLoader",
    text: "Loading People",
  },
  {
    api: "/api/Playbooks",
    loaderId: "simpleLoader",
    text: "Loading Playbooks",
  },

  //#region Translation
  {
    api: "/api/Translation/GetContainersForTarnslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetTextBlocksForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetContainerTitlesForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetImageBlocksForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetPlaybookLanguages",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GeResourcessForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/SaveTextBlocks",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/SaveContainerTitles",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetResourceForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/CopyDefaultImage",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetRefImageBlockId",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/CheckIfPlaybookExists",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetJsonFileForExportTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/SaveImportedJsonFileForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/GetImageBlockWithImageGroupForTranslation",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Translation/CreateImageBlockIfNotExists",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  //#endregion Translation

  //#region Playbook
  {
    api: "/api/Playbooks/PasteCopiedSection",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/Playbooks/PasteCopiedPage",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  //#region Draft
  {
    api: "/api/PlaybookDraft/DeleteAllDraftSectionsForPage",
    loaderId: "vPlaybookLogo",
    text: "Delete Draft",
  },
  {
    api: "/api/PlaybookDraft/CreateDraftForPage",
    loaderId: "vPlaybookLogo",
    text: "Creating Draft",
  },
  {
    api: "/api/PlaybookDraft/DeleteAllDraftSectionsForPage",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/PlaybookDraft/GetAllSectionsForPage",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/PlaybookDraft/ManageSectionsForPage",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  { api: "/api/Playbooks/Undo", loaderId: "vPlaybookLogo", text: "" },
  { api: "/api/Playbooks/Redo", loaderId: "vPlaybookLogo", text: "" },
  {
    api: "/api/Playbooks/GetUndoRedoHistory",
    loaderId: "vPlaybookLogo",
    text: "",
  },

  //#endregion Draft

  //#endregion Playbook

  //#region vBuilder client
  {
    api: "/api/VBuilder/SaveBuilderDetails",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  { api: "/api/VBuilder/PublishPlaybook", loaderId: "vPlaybookLogo", text: "" },
  {
    api: "/api/VBuilder/GetAllCategories",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/VBuilder/GetCompanyBuilder",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/VBuilder/AddBuilderPlaybook",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/VBuilder/UpdateBuilderPlaybook",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  {
    api: "/api/VBuilder/UpdatePagesInBuilderPlaybook",
    loaderId: "vPlaybookLogo",
    text: "",
  },

  //#endregion vBuilder client

  //#region Coaching

  //#region Admin Coaching

  //#region Dashboard
  {
    api: "/api/Challenge/GetChallengesByAdminId",
    loaderId: "simpleLoader",
    text: "Loading Dashboard",
  },
  {
    api: "/api/Challenge/GetManagersForChallenge",
    loaderId: "simpleLoader",
    text: "Loading Dashboard",
  },
  //#endregion Dashboard

  //#region Challenges
  {
    api: "/api/Challenge/GetChallengesByAdminId",
    loaderId: "simpleLoader",
    text: "Loading Challenges",
  },
  {
    api: "/api/ChallengeTemplate/ApplyChallengeTemplate",
    loaderId: "simpleLoader",
    text: "Applying Challenge Template",
  },
  {
    api: "/api/Challenge/ModifyChallengeDetailsForAdminChallenge",
    loaderId: "simpleLoader",
    text: "Updating Challenge",
  },
  {
    api: "/api/Challenge/CopyChallenge",
    loaderId: "simpleLoader",
    text: "Copying Challenge",
  },
  {
    api: "/api/Challenge/UpdateChallengeTitle",
    loaderId: "simpleLoader",
    text: "Updating Challenge Title",
  },
  {
    api: "/api/Challenge/CreateChallenge",
    loaderId: "simpleLoader",
    text: "Creating Challenge",
  },
  {
    api: "/api/Challenge/SaveChallengeSettings",
    loaderId: "simpleLoader",
    text: "Saving Challenge",
  },
  {
    api: "/api/Challenge/DeleteChallenge",
    loaderId: "simpleLoader",
    text: "Deleting Challenge",
  },
  {
    api: "/api/Challenge/AssignManagersToChallenge",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion Challenges

  //#region Challenge Template
  {
    api: "/api/ChallengeTemplate/GetCompanySpecificChallengeTemplates",
    loaderId: "simpleLoader",
    text: "Loading Challenge Templates",
  },
  {
    api: "/api/ChallengeTemplate/CopyChallengeTemplate",
    loaderId: "simpleLoader",
    text: "Copying Challenge Template",
  },
  {
    api: "/api/ChallengeTemplate/UpdateChallengeTemplateTitle",
    loaderId: "simpleLoader",
    text: "Updating Challenge Template Title",
  },
  {
    api: "/api/ChallengeTemplate/CreateChallengeTemplate",
    loaderId: "simpleLoader",
    text: "Creating Challenge Template",
  },
  {
    api: "/api/ChallengeTemplate/DeleteChallengeTemplate",
    loaderId: "simpleLoader",
    text: "Deleting Challenge Template",
  },
  {
    api: "/api/ChallengeTemplate/ModifyChallengeTemplateDetails",
    loaderId: "simpleLoader",
    text: "Updating Challenge Template Details",
  },
  //#endregion Challenge Template

  //#region Featured Content
  {
    api: "/api/Challenge/GetFeaturedContentByAdminId",
    loaderId: "simpleLoader",
    text: "Loading Featured Contents",
  },
  {
    api: "/api/Challenge/GetAllPreviewTiles",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Challenge/GetAllFiltersForAdminFeaturedContent",
    loaderId: "simpleLoader",
    text: "Getting Filters",
  },
  {
    api: "/api/Challenge/GetNonFeaturedContentByAdminId",
    loaderId: "simpleLoader",
    text: "Getting Non Featured Contents",
  },
  {
    api: "/api/Challenge/AddFeaturedContent",
    loaderId: "simpleLoader",
    text: "Creating Featured Content",
  },
  {
    api: "/api/Challenge/UpdateFeaturedContent",
    loaderId: "simpleLoader",
    text: "Updating Featured Content",
  },
  {
    api: "/api/Challenge/DeletePromotedContent",
    loaderId: "simpleLoader",
    text: "Deleting Featured Content",
  },
  {
    api: "/api/Challenge/ReOrderPromotedContent",
    loaderId: "simpleLoader",
    text: "Reordering Featured Contents",
  },
  //#endregion Featured Content

  //#region Challenge Response
  {
    api: "/api/Challenge/GetChallengeResponsesByCompanyId",
    loaderId: "simpleLoader",
    text: "Loading Challenge Responses",
  },
  //#endregion Challenge Response

  //#endregion Admin Coaching

  //#region Manager Coaching

  //#region Dashboard
  {
    api: "/api/Challenge/GetManagerInfoByManagerId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Challenge/GetManagerDashboard",
    loaderId: "simpleLoader",
    text: "Loading Dashboard",
  },
  //#endregion Dashboard

  //#region Challenges
  {
    api: "/api/Challenge/GetChallengesByManagerId",
    loaderId: "simpleLoader",
    text: "Loading Challenges",
  },
  {
    api: "/api/Challenge/GetAllReps",
    loaderId: "simpleLoader",
    text: "Loading Challenges",
  },
  {
    api: "/api/Challenge/ModifyChallengeDetails",
    loaderId: "simpleLoader",
    text: "Updating Challenge",
  },
  {
    api: "/api/Challenge/GetChallengesByRepsId",
    loaderId: "simpleLoader",
    text: "Loading Challenges",
  },
  //#endregion Challenges

  //#region Featured Content
  {
    api: "/api/Challenge/GetFeaturedContentByManagerId",
    loaderId: "simpleLoader",
    text: "Loading Featured Contents",
  },
  {
    api: "/api/Challenge/GetNonFeaturedContentByManagerId",
    loaderId: "simpleLoader",
    text: "Getting Non Featured Contents",
  },
  //#endregion Featured Content

  //#region Team Assessment
  {
    api: "/api/Challenge/GetAllRepsWithScore",
    loaderId: "simpleLoader",
    text: "Getting Info",
  },
  {
    api: "/api/TeamAssessment/GetAllTemplateByManagerId",
    loaderId: "simpleLoader",
    text: "Getting Info",
  },
  {
    api: "/api/TeamAssessment/GetTemplateWithAssesment",
    loaderId: "simpleLoader",
    text: "Getting Info",
  },
  {
    api: "/api/TeamAssessment/GiveAssesmentOnTemplate",
    loaderId: "simpleLoader",
    text: "Submitting assessment",
  },
  {
    api: "/api/TeamAssessment/ExportAssessment",
    loaderId: "simpleLoader",
    text: "Exporting Assessment",
  },
  {
    api: "/api/TeamAssessment/GetAllAdminTemplate",
    loaderId: "simpleLoader",
    text: "Loading Templates",
  },
  {
    api: "/api/TeamAssessment/ApplyTemplate",
    loaderId: "simpleLoader",
    text: "Applying Template",
  },
  {
    api: "/api/TeamAssessment/EditAssessmentTemplateDetails",
    loaderId: "simpleLoader",
    text: "Updating Assessment",
  },
  {
    api: "/api/TeamAssessment/AddTemplate",
    loaderId: "simpleLoader",
    text: "Creating Template",
  },
  {
    api: "/api/TeamAssessment/EditTemplate",
    loaderId: "simpleLoader",
    text: "Updating Template",
  },
  {
    api: "/api/TeamAssessment/DeleteTemplate",
    loaderId: "simpleLoader",
    text: "Deleting Template",
  },
  //#endregion Team Assessment

  //#region Challenge Response
  {
    api: "/api/Challenge/DeleteTaskResponseById",
    loaderId: "simpleLoader",
    text: "Deleting Response",
  },
  {
    api: "/api/Challenge/MarkResponse",
    loaderId: "simpleLoader",
    text: "Scoring Response",
  },
  {
    api: "/api/Challenge/ChangeScore",
    loaderId: "simpleLoader",
    text: "Updating Score",
  },
  //#endregion Challenge Response

  //#region Chat
  {
    api: "/api/Challenge/GetAllChatsByChallengeTaskParticipantId",
    loaderId: "simpleLoader",
    text: "Loading Feedback",
  },
  //#endregion Chat

  //#endregion Manager Coaching

  //#region Rep Coaching

  //#region Challenges
  {
    api: "/api/Challenge/GetChallengesByRepsId",
    loaderId: "simpleLoader",
    text: "Loading Challenges",
  },
  //#endregion Challenges

  //#region Dashboard
  {
    api: "/api/Challenge/GetParticipantDashboard",
    loaderId: "simpleLoader",
    text: "Loading Dashboard",
  },
  //#endregion Dashboard

  //#region Featured Content
  {
    api: "/api/Challenge/GetFeaturedContentByRepId",
    loaderId: "simpleLoader",
    text: "Loading Featured Contents",
  },
  //#endregion Featured Content

  //#region Featured Content
  {
    api: "/api/Challenge/GetChallengeOpenActivities",
    loaderId: "simpleLoader",
    text: "Getting Open Activities",
  },
  //#endregion Featured Content

  //#region Submit/View Activity Response
  {
    api: "/api/Challenge/RecordRepsResponse",
    loaderId: "simpleLoader",
    text: "Submitting Response",
  },
  {
    api: "/api/Challenge/DeleteTaskResponseById",
    loaderId: "simpleLoader",
    text: "Deleting Response",
  },
  //#endregion Featured Content

  //#endregion Rep Coaching

  //#endregion Coaching

  //#region Reports
  {
    api: "/api/Reports/GetUserPageviewsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Reports/GetTopUsersReport", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Reports/GetDailyPageviewsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetPlaybookAccessReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetPlaybookDownloadsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetTimeInPlaybookReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetOfflineLoginsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetInactiveUserReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetOfflineUserSyncReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetAllContentReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetDraftContentReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetManagerRepsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetOfflineAppUsageReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetResourceDownloadReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetResourceDetails",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetUserDetailsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetTopContentReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetTopTranslatedContent",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetUserRatingCommentsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetHighestRatedContentReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetChallengeOverviewReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetChallengeProgressReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetChallengeInteractionReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetSendGridEventsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetConversationUsagesReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetFolderAccessReport",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Reports/SendReportByEmail", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Reports/GetAllReportsDescription",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/UpdateReportDescription",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetReportColumnsById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetTranslatedPlaybookViewsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetSearchUsageReport",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Profiles/GetAllFilters", loaderId: "simpleLoader", text: "" },

  {
    api: "/api/Reports/GetBadgesCountReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetBadgesDetailsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetCollectionProgressReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetCollectionInteractionReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetLearningCenterOverviewReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetOptInCollectionParticipantReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetCollectionManagementOverviewReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetVideoViewsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetVideoInteractionsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetSearchLocationsReport",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Reports/DownloadReport", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Reports/GetChallengeResponseReport",
    loaderId: "simpleLoader",
    text: "",
  },

  {
    api: "/api/ScheduledReport/AddScheduledReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ScheduledReport/GetScheduledReprtsByProfileId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ScheduledReport/UpdateScheduledReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ScheduledReport/UnsubscribeRecipient",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ScheduledReport/ReadUnsubscribeUrl",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ScheduledReport/GenerateScheduledReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ScheduledReport/DeleteScheduledReport",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion Reports

  //#region Admin
  {
    api: "/api/VPlaybookAdmin/GetAllVplaybookAdmins",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/GetAdminById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/CreateVPlaybookAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/UpdateVplaybookAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/DeleteVPlaybookAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/ResendInviteeEmail",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/SendReminderAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/DownloadAdmins",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/SearchAllCompanies",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/GetCompanyInfoReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/GetCompanyStorageReport",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Profiles/DeleteProfile", loaderId: "simpleLoader", text: "" },
  { api: "`/api/Profiles/ResendInvite", loaderId: "simpleLoader", text: "" },
  //#endregion Admin

  //#region profile
  {
    api: "/api/Profiles/UpdateProfileInfo",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Profiles/UpdateProfileSignature",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Profiles/UpdateProfilePic", loaderId: "simpleLoader", text: "" },
  { api: "/api/Profiles/RemoveProfilePic", loaderId: "simpleLoader", text: "" },
  //#endregion profile

  //#region Playbook add contents
  { api: "/api/ContentRows", loaderId: "playbookloader", text: "" },
  {
    api: "/api/ContentRows/SetColumnsWidth",
    loaderId: "playbookloader",
    text: "",
  },
  {
    api: "/api/ContentRows/ResizeColumns",
    loaderId: "playbookloader",
    text: "",
  },
  { api: "/api/ContentColumns", loaderId: "playbookloader", text: "" },
  {
    api: "/api/ContentColumns/AddColumnToRowMoveRow",
    loaderId: "playbookloader",
    text: "",
  },
  {
    api: "/api/ContentBlocks/UpdateContentBlock",
    loaderId: "playbookloader",
    text: "",
  },
  { api: "/api/Containers/AddContainer", loaderId: "playbookloader", text: "" },
  {
    api: "/api/Containers/UpdateContainer",
    loaderId: "vPlaybookLogo",
    text: "",
  },
  { api: "/api/Containers/Delete", loaderId: "playbookloader", text: "" },
  {
    api: "/api/Containers/ReOrderContainers",
    loaderId: "playbookloader",
    text: "",
  },

  {
    api: "/api/TabsBlockElements/CopyTabElement",
    loaderId: "playbookloader",
    text: "",
  },
  {
    api: "/api/TabsBlockElements/DeleteTab",
    loaderId: "playbookloader",
    text: "",
  },

  //#endregion Playbook add contents

  //#region company
  { api: "/api/Companies", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Companies/PaginatedResults",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion company

  //#region page templates
  {
    api: "/api/PageTemplates/GetPageTemplatesForCompany",
    loaderId: "simpleLoader",
    text: "Getting Page Templates",
  },
  {
    api: "/api/PageTemplates/GetAllPageTemplatesInGroup",
    loaderId: "simpleLoader",
    text: "Getting Template Groups",
  },
  {
    api: "/api/PageTemplates/GetAllPageTemplateGroups",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PageTemplates/ApplyPageTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PageTemplates/UpdatePageTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PageTemplates/AddPageTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PageTemplates/CreatePageTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PageTemplates/CopyPageTemplate",
    loaderId: "simpleLoader",
    text: "Copying Page Templates",
  },
  {
    api: "/api/PageTemplates/GetPageTemplateManifest",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion page templates

  //#region Conversation Templates
  {
    api: "/api/ConversationTemplate/GetConversationTemplatesForCompany",
    loaderId: "simpleLoader",
    text: "Getting Conversation Templates",
  },
  {
    api: "/api/ConversationTemplate/GetFullConversationTemplateById",
    loaderId: "simpleLoader",
    text: "Loading Conversation Template",
  },
  {
    api: "/api/ConversationContent/RemoveQuestionTableColumn",
    loaderId: "simpleLoader",
    text: "Removing Table Column",
  },
  {
    api: "/api/ConversationTemplate/CopyConversationTemplate",
    loaderId: "simpleLoader",
    text: "Copying Conversation Template",
  },
  {
    api: "/api/ConversationTemplate/DeleteConversationTemplate",
    loaderId: "simpleLoader",
    text: "Deleting Conversation Template",
  },
  {
    api: "/api/ConversationTemplate/AssignConversationTemplateToPlaybook",
    loaderId: "simpleLoader",
    text: "Saving...",
  },
  {
    api: "/api/ConversationTemplate/AddConversationTemplate",
    loaderId: "simpleLoader",
    text: "Creating Conversation Template",
  },
  {
    api: "/api/ConversationTemplate/UpdateConversationTemplate",
    loaderId: "simpleLoader",
    text: "Updating Conversation Template",
  },
  {
    api: "/api/Conversations/SendConversationAsEmail",
    loaderId: "simpleLoader",
    text: "Exporting...",
  },
  {
    api: "/api/Conversations/GetConversationPdf",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ConversationContent/CopyConversationSection",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ConversationContent/PasteConversationSection",
    loaderId: "simpleLoader",
    text: "",
  },

  //#endregion Conversation Templates

  //#region playbook templates
  { api: "/api/PlaybookTemplates", loaderId: "simpleLoader", text: "" },
  { api: "/api/Playbooks/DeletePlaybook", loaderId: "simpleLoader", text: "" },
  { api: "/api/Playbooks/CopyPlaybook", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/PlaybookTemplates/AddPlaybookTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PlaybookTemplates/UpdatePlaybookTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion playbook templates

  //#region People
  { api: "/api/Profiles/GetProfileById", loaderId: "simpleLoader", text: "" },
  { api: "/api/Profiles/CreateProfile", loaderId: "simpleLoader", text: "" },
  { api: "/api/Profiles/UpdateProfile", loaderId: "simpleLoader", text: "" },
  { api: "/api/Profiles/DeleteProfile", loaderId: "simpleLoader", text: "" },
  { api: "/api/Profiles/ImportUsers", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Profiles/DownloadCompanyUsers",
    loaderId: "simpleLoader",
    text: "",
  },

  {
    api: "/api/VPlaybookAdmin/GetAdminById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/CreateVPlaybookAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/UpdateVplaybookAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/DeleteVPlaybookAdmin",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/VPlaybookAdmin/DownloadAdmins",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PermissionGroup/CreatePermissionGroup",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PermissionGroup/UpdatePermissionGroup",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion People

  //ManagerRepHierarchy
  {
    api: "/api/Profiles/CheckMangerRepHierarchyEstablished",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Profiles/GetManagerRepHierarchyForPeopleConsole",
    loaderId: "simpleLoader",
    text: "",
  },
  //endregion ManagerRepHierarchy

  //#region playbook settings
  { api: "/api/Playbooks/AddPlaybook", loaderId: "simpleLoader", text: "" },
  { api: "/api/Playbooks/UpdatePlaybook", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Playbooks/UpdatePlaybookCoversColors",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ContentNotifications/UpdateContentNotification",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/ExportPlaybookJson",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/SavePlaybookJson",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/GetPlaybookFeaturedContentById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/AddPlaybookFeaturedContent",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/UpdatePlaybookFeaturedContent",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/DeletePlaybookFeaturedContent",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/GetEditTrackingListForPlaybookFeaturedContent",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/GetAllFiltersForPlaybookFeatureContent",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion playbook settings

  //#region lms
  { api: "/api/Badges/GetUserBadges", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/CollectionGlobalSettings/GetCollectionGlobalSettingByCompanyId",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Collections/AddCollection", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Collections/UpdateCollection",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/AssignManagersToCollection",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionGlobalSettings/AddCollectionGlobalSetting",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionGlobalSettings/UpdateCollectionGlobalSetting",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivities/AddActivity",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivities/UpdateActivity",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetCollectionById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/GetAllPlaybooksAndResources",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivities/GetActivityById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionLeaderboard/GetManagerLeaderboardByCollectionId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetAllCollectionsByCompanyId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetCollectionsByManagerId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionLeaderboard/GetCollectionManagers",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionLeaderboard/GetAdminLeaderboardByCollectionId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionLeaderboard/GetCollectionListForAdminLeaderboard",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionLeaderboard/GetCollectionBreakdownByParticipants",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Scorm/GetListOfCourses", loaderId: "simpleLoader", text: "" },
  { api: "/api/SCORM/UploadSCORMCourse", loaderId: "simpleLoader", text: "" },
  { api: "/api/SCORM/DeleteCourse", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/SCORM/GetCourseRegistrationId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/SCORM/CreateCourseRegistrationId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/SCORM/GetCoursePreviewLaunchLink",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/SCORM/GetRegistrationProgress",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivityResponse/AddCollectionActivityResponse",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/ActivateCollection",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivityResponse/GetAllActivityResponsesForScoring",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetUserCollectionsBadges",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Playbooks/GetFullPlaybookManifestForLMS",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivityResponse/GetAllCollectionActivityResponses",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivities/GetAllActivities",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetUserCollectionDashboardDetails",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetCollectionsByRepsId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetCollectionCompletionByCollectionId",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivityScore/AddCollectionActivityScore",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionActivityResponse/DeleteCollectionActivityResponse",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/OnlineAnalytics/ClearVideoAnalyticsForCollectionActivity",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/DeleteChatMessage",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/GetChatDetails",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/GetAllChatsForProfile",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/AddDirectMessage",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/GetCollectionResponseForCompany",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/GetCollectionResponseDetailsById",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/GetCollectionsDetailsForFilter",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/DeleteProfileChat",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/AddActivityFeedbackMessage",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/AddMessageToExistingChat",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/PinChatForProfile",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/CollectionFeedback/UnpinChatForProfile",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/GetCollectionTemplates",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Collections/CopyCollectionTemplate",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion lms

  {
    api: "/api/Resources/GetAssetByResourceId",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Assets/Resource/", loaderId: "simpleLoader", text: "" },
  { api: "/api/Assets/GetResourceById/", loaderId: "simpleLoader", text: "" },

  //#region animation
  {
    api: "/api/ContentBlocks/UpdateContentBlockAnimation",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ContentBlocks/DeleteAnimation",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion animation
  {
    api: "/api/UserPermissionType/GetUserPermissionTypesForCompany",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/UserPermissionType/UpdateUserPermissionTypeCommand",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Profiles/BulkLockProfileType",
    loaderId: "simpleLoader",
    text: "",
  },

  //#region playbook mobile editor
  {
    api: "/api/PlaybookMobileView/ReOrderPlaybookContent",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PlaybookMobileView/GetPlaybookFooterItems",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PlaybookMobileView/SavePlaybookFooterItems",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/PlaybookMobileView/HidePlaybookContent",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion playbook mobile editor

  //#region download chart, insight metrics data
  {
    api: "/api/ReportsInsight/GetAllMetricsData",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Widgets/GetChartImageAsPdf",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/ReportsInsight/DownloadAllMetricsData",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Widgets/GetAllProfileWidgets",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/api/Widgets/AddWidget", loaderId: "simpleLoader", text: "" },
  { api: "/api/Widgets/UpdateWidget", loaderId: "simpleLoader", text: "" },
  { api: "/api/Widgets/DeleteWidget", loaderId: "simpleLoader", text: "" },
  {
    api: "/api/Widgets/BulkAddUpdateWidgets",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion download chart, insight metrics data

  //#region admin reports
  { api: "/v2/api/admin/Reports/Metrics", loaderId: "simpleLoader", text: "" },
  {
    api: "/v2/api/admin/Reports/DownloadMetrics",
    loaderId: "simpleLoader",
    text: "",
  },
  { api: "/v2/api/admin/Reports", loaderId: "simpleLoader", text: "" },
  { api: "/v2/api/admin/Reports/Filters", loaderId: "simpleLoader", text: "" },
  { api: "/v2/api/admin/Reports/Columns", loaderId: "simpleLoader", text: "" },
  {
    api: "/v2/api/admin/Reports/PlaybookAdoption",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/v2/api/admin/reports/LearningCollectionUsage",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/CollectionResponseReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Reports/EmailEngagementReport",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/v2/api/Resources/Search",
    loaderId: "simpleLoader",
    text: "",
  },
  //#endregion admin reports
  {
    api: "/api/Assets/Resource/",
    loaderId: "simpleLoader",
    text: "",
  },
  {
    api: "/api/Companies/GenerateApiKey",
    loaderId: "simpleLoader",
    text: "",
  },
];
